import React, { memo } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import useLocales from 'src/hooks/useLocales';

import { HyperlinkProps } from '../types/elementSettingsTypes';

type ElementHyperlinkSettingsProps = {
  hyperlink: HyperlinkProps;
  onHyperlinkChange: (hyperlink: HyperlinkProps) => void;
};

const ElementHyperlinkSettings: React.FC<ElementHyperlinkSettingsProps> = ({
  hyperlink,
  onHyperlinkChange,
}) => {
  const { t } = useLocales();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label={`${t('forms.elements.settings.linkText')}`}
        value={hyperlink.text}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onHyperlinkChange({ ...hyperlink, text: event.target.value });
        }}
        id="RWemh7u"
      />

      <TextField
        label={`${t('forms.elements.settings.websiteAddress')}`}
        value={hyperlink.url}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onHyperlinkChange({ ...hyperlink, url: event.target.value });
        }}
        id="RWe8f6f"
      />
    </Box>
  );
};

export default memo(ElementHyperlinkSettings);
